import React from 'react';
import { Component } from 'react';
import "./PasswordChangePage.scss";
import PasswordChangeScreen from '../../components/screens/PasswordChange/PasswordChangeScreen';
import ContactScreen from '../../components/screens/Contact/ContactScreen';

type PasswordChangePageProps = {
};

export default class PasswordChangePage extends Component<PasswordChangePageProps> {

    public render() {
        const searchParams = new URLSearchParams(window.location.search);
        let token = searchParams.get('token')
        return (
            <div>
                <div className="web-container">

                    <section id="forgotten-password">
                        <PasswordChangeScreen token={token} />
                    </section>

                    <section id="contact">
                        <ContactScreen
                        header="Skontaktuj się z nami"
                        />
                    </section>
                </div>
            </div>
        )

    }
}